var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user && _vm.artist_role)?_c('div',[_c('ArtistDashboard')],1):(_vm.user && _vm.label_role)?_c('div',[_c('LabelDashboard')],1):(_vm.user && _vm.content_role)?_c('div',[_c('ContentHome')],1):(_vm.user)?_c('div',[_c('AdminDashboard')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }